(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-gallery"] && !Shopify.designMode) return;
  try {
    function initGalleryCard(card) {
    if (card.dataset.gcardInit === "true") return;
    card.dataset.gcardInit = "true";

    var addBtn = card.querySelector("[data-gcard-add]");
    if (!addBtn) return;

    addBtn.addEventListener("click", function () {
      if (addBtn.hasAttribute("disabled")) return;
      var id = addBtn.getAttribute("data-variant-id");
      var url = addBtn.getAttribute("data-add-url") || "/cart/add.js";
      var original = addBtn.textContent;
      addBtn.disabled = true;
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.textContent = "Agregado ✓";
          document.dispatchEvent(new CustomEvent("cart:updated"));
          setTimeout(function () {
            addBtn.textContent = original;
            addBtn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          addBtn.textContent = "Intenta de nuevo";
          setTimeout(function () {
            addBtn.textContent = original;
            addBtn.disabled = false;
          }, 1600);
        });
    });
  }

  function bootGalleryCards(scope) {
    (scope || document).querySelectorAll("[data-gcard]").forEach(initGalleryCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootGalleryCards(document);
    });
  } else {
    bootGalleryCards(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    bootGalleryCards(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function initProductCard(card) {
    if (card.dataset.pcardInit === "true") return;
    card.dataset.pcardInit = "true";

    var toggle = card.querySelector("[data-pcard-toggle]");
    var addBtn = card.querySelector("[data-pcard-add]");
    // OJO: aqui iba querySelectorAll("[data-variant-id]"), que tambien agarraba el
    // boton Agregar (tiene ese atributo con la variante por defecto). Resultado: al
    // picar Agregar se disparaba tambien selectSize(addBtn), que ponia `selected` en
    // el propio boton y mandaba SIEMPRE la variante por defecto al carrito, ademas de
    // escribir "Agregar · null" porque el boton no tiene data-price.
    var sizes = Array.prototype.slice.call(card.querySelectorAll("[data-pcard-size]"));
    var selected = card.querySelector(".pcard__size.is-active") || sizes[0] || null;
    var addUrl = addBtn ? addBtn.getAttribute("data-add-url") : "/cart/add.js";

    function selectSize(btn) {
      sizes.forEach(function (s) {
        s.classList.toggle("is-active", s === btn);
      });
      selected = btn;
      var precio = btn.getAttribute("data-price");
      if (addBtn && precio) {
        addBtn.textContent = "Agregar · " + precio;
      }
    }

    sizes.forEach(function (s) {
      s.addEventListener("click", function (event) {
        event.preventDefault();
        if (s.hasAttribute("disabled")) return;
        selectSize(s);
      });
    });

    if (toggle) {
      toggle.addEventListener("click", function () {
        card.classList.toggle("is-open");
      });
    }

    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var id = selected ? selected.getAttribute("data-variant-id") : addBtn.getAttribute("data-variant-id");
        if (!id) return;
        var original = addBtn.textContent;
        addBtn.disabled = true;
        fetch(addUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            addBtn.textContent = "Agregado ✓";
            document.dispatchEvent(new CustomEvent("cart:updated"));
            setTimeout(function () {
              addBtn.textContent = original;
              addBtn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            addBtn.textContent = "Intenta de nuevo";
            setTimeout(function () {
              addBtn.textContent = original;
              addBtn.disabled = false;
            }, 1600);
          });
      });
    }
  }

  function bootProductCards(scope) {
    (scope || document).querySelectorAll("[data-pcard]").forEach(initProductCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootProductCards(document);
    });
  } else {
    bootProductCards(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    bootProductCards(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
